import React from 'react';
import { useRouter } from 'next/router';
import { PillMenu, PillMenuItem } from 'components/PillMenu';
import { MenuItem } from 'components/MainNavigationMenu/types';

interface Props {
  isAdmin: boolean;
  isUserMember?: boolean;
  menuItems: MenuItem[];
  className?: string;
  onRouteChange?: (newPath: string) => void;
}

const NavigationMenu = ({
  isAdmin,
  isUserMember,
  menuItems,
  className = 'mb-5',
  onRouteChange
}: Props) => {
  const router = useRouter();
  const { pathname } = router;

  const handleRouterChange = (newPath) => {
    if (newPath !== '') {
      // Call custom route change handler if provided
      if (onRouteChange) {
        onRouteChange(newPath);
      } else {
        router.push(newPath);
      }
    }
  };

  return (
    <div className={`${className} mb-5 overflow-hidden`}>
      <PillMenu>
        {menuItems.map((item) => {
          if (!item.condition?.(isAdmin) || !isUserMember) {
            return null;
          }

          const isActive = Array.isArray(item.values)
            ? item.values.includes(pathname)
            : pathname === item.value;

          const handleClick = () => {
            const targetPath = Array.isArray(item.values)
              ? item.values[0]
              : item.value;
            handleRouterChange(targetPath);
          };

          return (
            <PillMenuItem
              key={item.label}
              active={isActive}
              onClick={handleClick}
            >
              {item.icon} {item.label}
            </PillMenuItem>
          );
        })}
      </PillMenu>
    </div>
  );
};

export default NavigationMenu;
